//配置API接口地址
var API_BIDATA = process.env.API_BIDATA;
var API_BIDATAS = process.env.API_BIDATAS;
var API_WX = process.env.API_WX;
// 返回在vue模板中的调用接口
export {
    API_BIDATA,
    API_BIDATAS,
    API_WX
}



//////////////////
// WEBPACK FOOTER
// ./config/api.js
// module id = 220
// module chunks = 10